/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Forward_One_FrameInputs */

const en_shortcut_keys_name_forward_one_frame = /** @type {(inputs: Shortcut_Keys_Name_Forward_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forward 1 Frame`)
};

const fr_shortcut_keys_name_forward_one_frame = /** @type {(inputs: Shortcut_Keys_Name_Forward_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avancer de 1 image`)
};

const de_shortcut_keys_name_forward_one_frame = /** @type {(inputs: Shortcut_Keys_Name_Forward_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorwärts 1 Frame`)
};

const it_shortcut_keys_name_forward_one_frame = /** @type {(inputs: Shortcut_Keys_Name_Forward_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanti 1 fotogramma`)
};

const ru_shortcut_keys_name_forward_one_frame = /** @type {(inputs: Shortcut_Keys_Name_Forward_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вперед 1 кадр`)
};

const es_shortcut_keys_name_forward_one_frame = /** @type {(inputs: Shortcut_Keys_Name_Forward_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanzar 1 fotograma`)
};

const zh_cn2_shortcut_keys_name_forward_one_frame = /** @type {(inputs: Shortcut_Keys_Name_Forward_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向前 1 帧`)
};

const ja_shortcut_keys_name_forward_one_frame = /** @type {(inputs: Shortcut_Keys_Name_Forward_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1フレーム進む`)
};

const hi_shortcut_keys_name_forward_one_frame = /** @type {(inputs: Shortcut_Keys_Name_Forward_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 फ्रेम आगे`)
};

const pt_pt2_shortcut_keys_name_forward_one_frame = /** @type {(inputs: Shortcut_Keys_Name_Forward_One_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avançar 1 quadro`)
};

/**
* | output |
* | --- |
* | "Forward 1 Frame" |
*
* @param {Shortcut_Keys_Name_Forward_One_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_forward_one_frame = /** @type {((inputs?: Shortcut_Keys_Name_Forward_One_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Forward_One_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_forward_one_frame(inputs)
	if (locale === "de") return de_shortcut_keys_name_forward_one_frame(inputs)
	if (locale === "it") return it_shortcut_keys_name_forward_one_frame(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_forward_one_frame(inputs)
	if (locale === "es") return es_shortcut_keys_name_forward_one_frame(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_forward_one_frame(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_forward_one_frame(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_forward_one_frame(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_forward_one_frame(inputs)
	return en_shortcut_keys_name_forward_one_frame(inputs)
});